import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useStore } from '../../context/StoreContext';

const R = (n) => `R ${Number(n).toFixed(0)}`;

export default function ProductCard({ p }) {
  const { addToCart, toggleWish, wishlist, cacheProduct } = useStore();
  const wished = wishlist.includes(p.id);
  React.useEffect(() => { cacheProduct && cacheProduct(p); }, [p, cacheProduct]);
  return (
    <div className="group relative">
      <Link to={`/product/${p.id}`} className="block overflow-hidden bg-champagne">
        <div className="aspect-[4/5] w-full overflow-hidden">
          <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>
      </Link>
      <button onClick={() => toggleWish(p.id)} aria-label="Wishlist" className="absolute right-3 top-3 grid size-9 place-items-center bg-ivory/90 text-espresso transition hover:bg-gold">
        <Heart className={`size-4 ${wished ? 'fill-espresso' : ''}`} />
      </button>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <Link to={`/product/${p.id}`} className="font-display text-lg leading-tight hover:text-gold">{p.title}</Link>
          {p.tagline && <p className="mt-1 text-xs text-espresso/60">{p.tagline}</p>}
        </div>
        <span className="shrink-0 text-sm text-espresso">{R(p.price)}</span>
      </div>
      <button onClick={() => addToCart(p.id, 1, p)} className="mt-3 w-full border border-espresso py-2.5 text-[11px] tracking-[0.18em] text-espresso transition hover:bg-espresso hover:text-ivory">ADD TO BAG</button>
    </div>
  );
}
